<template>
  <div class="login-page full-height flex ai-c jc-c fd-c fgap2">
    <router-link :to="{ name: 'Login' }">
      <img
        alt="Prime Internacional"
        src="https://s3.sa-east-1.amazonaws.com/public.prime.com.vc/logo/nova/logo-horizontal-branca.svg"
        width="350"
      >
    </router-link>
    <div class="offwhite-bg medium-border-radius pv-4 ph-6 text-center flex fd-c jc-c">
      <h1 class="mb-1 text-xg text-bold">Portal dos Clientes</h1>
      <p class="mb-3">Digite o seu email e senha para acessar!</p>

      <form class="flex fd-c fgap2" @submit.prevent="login">
        <Input
          v-model="userData.email"
          :required="true"
          className="input-login"
          label="Email"
          name="email"
          placeholder="Seu email"
          type="email"
        />

        <Input
          v-model="userData.senha"
          :error="error"
          :required="true"
          className="input-login"
          label="Senha"
          name="senha"
          placeholder="Sua senha"
          type="password"
        />

        <div class="pv-1 text-right">
          <router-link :to="{name: 'ForgotPassword'}">Esqueceu sua senha?</router-link>
        </div>

        <button class="btn solid primary full-width extra-big btn-auth" type="submit">ACESSAR</button>
        <div v-if="loading">carregando</div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
// eslint-disable-next-line import/no-cycle
import api from '@/services/api';
import apiBi from '@/services/apiBi';
import Input from '@/components/DataInput/Input.vue';
import axios from 'axios';
import {
  canAccessRoute,
  getFallbackRouteName,
} from '@/utils/portalPermissionAccess';

export default {
  name: 'Login',
  components: {
    Input,
  },
  computed: {
    ...mapState(['loading']),
  },
  data() {
    return {
      userData: {
        email: '',
        senha: '',
      },
      error: new Error(),
    };
  },
  methods: {
    ...mapActions(['toggleLoading']),
    ...mapActions('auth', ['updateUser', 'loadCompanyPermissions']),
    async login() {
      this.toggleLoading(true);
      this.error = new Error();

      try {
        const params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('username', this.userData.email);
        params.append('password', this.userData.senha);

        await api.post('/oauth/token', params, {
          auth: {
            username: process.env.VUE_APP_API_USER,
            password: process.env.VUE_APP_API_PWD,
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });

        const userResponse = await api.get('/credential');

        this.updateUser(userResponse.data.data);
        await this.loadCompanyPermissions();

        // await apiBi.post('/gescomex/auth', {
        //   email: this.userData.email,
        //   password: this.userData.senha,
        // }).catch((erro) => {
        //     console.log('gescomex/auth - erro: ', erro.message);
        // });

        const companyPermissions = this.$store.state.auth.companyPermissions;
        const previousRoute = localStorage.getItem('previousRoute');

        if (previousRoute) {
          localStorage.removeItem('previousRoute');
          const { route } = this.$router.resolve(previousRoute);
          const hasAccess = route.name && canAccessRoute(companyPermissions, route.name);

          if (hasAccess) {
            await this.$router.push(previousRoute);
          } else {
            await this.$router.push({ name: getFallbackRouteName(companyPermissions) });
          }
        } else {
          await this.$router.push({ name: getFallbackRouteName(companyPermissions) });
        }

      } catch (err) {
        if (err.message === 'Bad credentials' || err?.response?.status === 400) {
          this.$toast.error('Usuário ou senha inválido.');
          this.error = new Error('Usuário ou senha inválido.');
        } else {
          this.$toast.error('Houve algum problema ao tentar realizar o login. Caso o problema continue, entre em contato conosco.');
        }
      } finally {
        this.toggleLoading(false);
        await this.saveAccessLog();
      }
    },
    async saveAccessLog() {
      const response = await axios.get(
        'https://ipinfo.io/?token=66401ea11bcd92',
      );

      if (
        (response.data.ip !== null || response.data.ip !== '')
        && response.data.city !== null
        && response.data.region !== ''
      ) {
        try {
          const data = {
            ipAddress: response.data.ip,
            origin: `${response.data.city} - ${response.data.region} - ${response.data.country}`,
            tag: 'PORTAL_CLIENTES',
            provider: response.data.org,
          };

          await api.post('/userAccessLogs', data);
        } catch {
          console.error('Erro ao salvar log de acesso!');
        }
      } else {
        console.log('Dados principais do log não foram encontrados!');
      }
    },
  },
};
</script>

<style scoped>
.login-page {
  background: #161635;
}

form {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
}

.btn.solid.primary.btn-auth {
  background-color: #161635;
  border-color: #161635;
  color: #fff;
}

.btn.solid.primary.btn-auth:hover {
  background-color: transparent;
  border-color: #161635;
  color: #161635;
}

@media screen and (max-width: 1300px) {
  .login-page.columns {
    grid-template-columns: 1fr;
    background: var(--white-color);
  }
}
</style>
